<template>
    <div id="user">
        <van-cell-group>
            <van-cell class="user-setting" to="/user/setting">
                <template slot="title">
                    <span class="user-photo" :style="{backgroundImage:'url('+src+')'}"></span>
                    <div class="van-cell-text">
                        <h3 class="username">{{userName}}</h3>
                        <p class="desc">
                            <span class="address">{{districtName}}</span>
                        </p>
                    </div>
                    <van-icon class="icon-arror" name="arrow"></van-icon>
                </template>
            </van-cell>
        </van-cell-group>
        <van-cell-group>
            <van-cell title="我的订单" is-link to="/order/myorder"/>
            <van-cell title="修改密码" is-link to="/user/changepwd"/>
            <!-- <van-cell title="通讯录" is-link to="/user/addressbook"/>
            <van-cell title="投诉建议" is-link to="/user/suggestion"/> -->
          <van-cell title="退出登录" is-link @click="logout"/>
        </van-cell-group>
    </div>
</template>

<script>
export default {
  name: "user",
  data() {
    return {
      userName: "",
      districtName: "",
      src: require("../../assets/logo_wbg.png")
    };
  },
  created() {
    this.ready();
  },
  methods: {
    // 进入页面
    ready() {
      var params = {
        params: {
          mobile: this.$store.state.mobile,
          loginType: 5
          }
      };
      this.$axios.post("user/getUserInfo", params).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data;
          if (data.photo) {
            this.src = data.photo;
          }
          this.districtName = data.districtName;
          this.userName = data.nickname;
        }
      });
    },
    logout() {
      this.$store.commit({
        type: "logout"
      });
      this.$router.push("/user/login");
    }
  }
};
</script>

<style scoped lang="scss">
#user {
  .user-setting {
    &:active {
      background-color: #e8e8e8;
    }
    .user-photo {
      width: 1.75rem;
      height: 1.75rem;
      border: 1px solid #ddd;
      border-radius: 50%;
      float: left;
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
    }
    .van-cell-text {
      margin-left: 0.25rem;
      height: 1.75rem;
      float: left;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      width: 50%;
      .username {
        font-size: 0.45rem;
      }
      .desc {
        font-size: 0.35rem;
        color: #777;
        .address {
          margin-right: 20px;
          &:after {
            content: "";
            border-left: 1px solid #ddd;
            position: relative;
            left: 10px;
          }
        }
      }
    }
    .icon-arror {
      position: absolute;
      right: 15px;
      top: 50%;
      -webkit-transform: translateY(-50%);
      -moz-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      -o-transform: translateY(-50%);
      transform: translateY(-50%);
      font-size: 12px;
    }
  }
}
</style>
